import { END_POINTS } from "../helpers";
import emptySplitApi from "../utils/rtk";

type CommonResponseType = {
  data: ResponseData;
  status: number;
  message: string;
};
type ResponseData = {
  response_object: any;
  total_records: number;
  start: number;
  length: number;
};

type getExchangeBody = {
  start: number;
  length: number;
  search: string;
  type: number;
};

type UpdateExchangeBody = {
  body: any;
  id: any;
};

export const quoteApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getReturnExchange: builder.mutation<
      CommonResponseType & { data: any },
      getExchangeBody
    >({
      query: (body) => ({
        url: END_POINTS.returnExchangeListings,
        method: "POST",
        body,
      }),
    }),

    updateReturnExchangeStatus: builder.mutation<
      CommonResponseType & { data: any },
      UpdateExchangeBody
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.orderStatusUpdate}${id}/`,
        method: "PUT",
        body,
      }),
    }),

    returnAcceptReject: builder.mutation<
      CommonResponseType & { data: any },
      UpdateExchangeBody
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.returnAcceptReject}${id}/`,
        method: "POST",
        body,
      }),
    }),

    ExchangeAcceptReject: builder.mutation<
      CommonResponseType & { data: any },
      UpdateExchangeBody
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.exchangeAcceptReject}${id}/`,
        method: "POST",
        body,
      }),
    }),

    getReturnExchangeById: builder.query<
      CommonResponseType & { data: any },
      { id: string | undefined; type: number }
    >({
      query: ({ id, type }) => ({
        url: `${END_POINTS.exchangeById}${id}/${type}/`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetReturnExchangeMutation,
  useUpdateReturnExchangeStatusMutation,
  useExchangeAcceptRejectMutation,
  useReturnAcceptRejectMutation,
  useLazyGetReturnExchangeByIdQuery,
} = quoteApi;
